export const makeVideos = function makeVideos() {
  let videos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return videos.reduce((acc, video) => {
    acc[video.id] = {
      watched: video.watched
    };
    return acc;
  }, {});
};
export const makeNoVideos = () => makeVideos([]);